export const REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
}

export const REQUEST_STATUS_LABELS = {
  pending: 'Pendente',
  approved: 'Aprovada',
  rejected: 'Rejeitada',
}

export const REQUEST_STATUS_VARIANTS = {
  pending: 'light-warning',
  approved: 'light-success',
  rejected: 'light-danger',
}

export const REQUEST_STATUS_OPTIONS = [
  { value: REQUEST_STATUS.PENDING, text: REQUEST_STATUS_LABELS.pending },
  { value: REQUEST_STATUS.APPROVED, text: REQUEST_STATUS_LABELS.approved },
  { value: REQUEST_STATUS.REJECTED, text: REQUEST_STATUS_LABELS.rejected },
]

export const statusLabel = status => REQUEST_STATUS_LABELS[status] || status

export const statusVariant = status => REQUEST_STATUS_VARIANTS[status] || 'light-secondary'

export const APPROVER_ACTION_LABELS = {
  added: 'Inclusão',
  removed: 'Remoção',
}

export const approverActionLabel = action => APPROVER_ACTION_LABELS[action] || action
